import * as Yup from 'yup'
import { NumberSchema } from 'yup'

//TODO: get rid of this hack when yup fixes the issue: https://github.com/jquense/yup/issues/177
Yup.addMethod(Yup.number, 'strong', function() {
  return this.transform(function(value, original) {
    let parsed = original

    if (typeof parsed === 'string') {
      parsed = parsed.replace(/\s/g, '')
      if (parsed === '') {
        return NaN
      }
      // don't use parseFloat to avoid positives on alpha-numeric strings
      parsed = +parsed
    }
    if (this.isType(parsed)) {
      return parsed
    }
    return parseFloat(parsed)
  })
})

export interface IFixedNumberSchema extends NumberSchema {
  strong: () => IFixedNumberSchema
}

export const yupNumberStrong = (): IFixedNumberSchema => {
  return (Yup.number() as IFixedNumberSchema).strong()
}



// WEBPACK FOOTER //
// ./src/utils/yup.ts